import compact from 'lodash/compact'
import { GeckoEntry } from 'types'

import type { AnnotationWithModel, RawRooftopAnnotation } from './types'

const CM2_TO_FT2_CONVERSION = 929.03

export const convertAreaCm2ToFt2 = (areaCm2: number): number =>
  areaCm2 / CM2_TO_FT2_CONVERSION

export const getAnnotationId = (annotation: RawRooftopAnnotation): string =>
  annotation.annotationId || annotation.id || ''

export const extractRooftopAnnotations = (
  kestrelModels: readonly GeckoEntry[]
): AnnotationWithModel[] => {
  return compact(
    kestrelModels.flatMap((model) => {
      const anns =
        (model.data?.annotations as RawRooftopAnnotation[] | undefined) ?? []
      return anns.map((a) => ({ a, modelId: model.id }))
    })
  )
}

export const filterPolygonAnnotations = (
  annotations: AnnotationWithModel[]
): AnnotationWithModel[] => {
  return annotations.filter(({ a }) => a.geometry?.kind === 'polygon')
}

export const calculateTotalDamagedArea = (
  polygonAnnotations: AnnotationWithModel[]
): number => {
  return polygonAnnotations.reduce((sum, { a }) => {
    const areaCm2 = a.area
    if (areaCm2) {
      return sum + convertAreaCm2ToFt2(areaCm2)
    }
    return sum
  }, 0)
}
